import { type AnyAction, type CaseReducer, type Draft, type PayloadAction } from "@reduxjs/toolkit";
import { type SearchParamsState } from '../searchParameters'

export const setSearchParamsAction: CaseReducer<
  SearchParamsState,
  PayloadAction<SearchParamsState>
> = (state: Draft<SearchParamsState>, action: AnyAction) => {
  state.searchText = action.payload.searchText
  state.pageToken = action.payload.pageToken
}